import type { TOC } from '@ember/component/template-only';
import GeneralPageMain from 'lumen/components/general/page/main';
import SettingsDrawerSidebar from 'lumen/components/settings/drawer/sidebar';

<template>
  <GeneralPageMain class="navbar-settings">
    <SettingsDrawerSidebar />
    <div class="content-wrapper main-content flex flex-col gap-0">
      {{outlet}}
    </div>
  </GeneralPageMain>
</template> satisfies TOC<object>;
